import React, { Component } from 'react';
import ConfigMapaMacroscopicoPage from './mapa-macroscopico.page';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as commonActions from '../../../../app/common/common.action';
import WebapiCommon from '../../../../app/common/util/webapi.common';

class ConfigMapaMacroscopicoContainer extends Component {
  constructor() {
    super();
    this.state = {
      teveAlteracao: false,
      configs: [],
    };
  }

  componentDidMount() {
    this.props.commonActions.showFadeCarregando(true);
    Promise.all([
      WebapiCommon.getConfiguracaoMapaMacroscopico(),
      WebapiCommon.getMedicos(),
    ]).then((response) => {
      const configuracoes = response[0];
      const medicos = response[1];

      let configs = [];

      configuracoes.configuracoesMapaMacroscopicoItems.forEach((el, i) => {
        if (el.coluna === 'Cd_med_padrao_macro') {
          configs.push({
            id: i,
            nome: el.label,
            options: medicos,
            value: medicos.find((obj) => obj.value === el.valor),
            key: el.coluna,
          });
        } else {
          configs.push({
            id: i,
            nome: el.label,
            valor: el.valor,
            key: el.coluna,
          });
        }
      });

      this.setState({
        configs,
      });

      this.props.commonActions.showFadeCarregando(false);
    });
  }

  render() {
    return (
      <ConfigMapaMacroscopicoPage
        toggleSwitch={this.toggleSwitch.bind(this)}
        configs={this.state.configs}
        altura={this.props.altura}
        salvar={this.salvar.bind(this)}
        updateStateMedicoPadraoMacroscopista={this.updateStateMedicoPadraoMacroscopista.bind(
          this
        )}
        numeroMaximoLaminasUpdate={this.numeroMaximoLaminasUpdate.bind(this)}
      />
    );
  }

  toggleSwitch(id, valor) {
    var configs = this.state.configs;
    configs.map((conf) => {
      if (conf.id === id) {
        conf.valor = valor;
      }
      return conf;
    });
    this.setState({
      configs,
    });

    if (!this.state.teveAlteracao) this.setState({ teveAlteracao: true });
  }

  salvar() {
    if (this.state.teveAlteracao) {
      this.props.commonActions.showFadeCarregando(true);

      let configuracoesMapaMacroscopicoRequest = [];

      this.state.configs.forEach((el) => {
        configuracoesMapaMacroscopicoRequest.push({
          label: el.nome,
          valor: this.getValorConfiguracao(el),
          coluna: el.key,
        });
      });

      WebapiCommon.gravarConfiguracaoMapaMacroscopico(
        configuracoesMapaMacroscopicoRequest
      ).then((response) => {
        this.props.commonActions.showFadeCarregando(false);
        this.props.commonActions.showAlerta(
          response ? 'sucesso' : 'erro',
          response
            ? 'Configuração salva com sucesso!'
            : 'Não foi possível alterar as configurações.',
          2500
        );
      });
    }
  }

  getValorConfiguracao(el) {
    return el.key === 'Cd_med_padrao_macro' ? el.value.value : el.valor;
  }

  updateStateMedicoPadraoMacroscopista(valor) {
    let config = [...this.state.configs];
    let exePadrao = config.find((el) => el.key === 'Cd_med_padrao_macro');

    if (exePadrao) {
      exePadrao.value = valor;
      this.setState({
        configs: config,
        teveAlteracao: true,
      });
    }
  }

  numeroMaximoLaminasUpdate(event) {
    let configs = this.state.configs;

    configs.find((el) => el.key === 'Limitelaminas').valor =
      // eslint-disable-next-line radix
      parseInt(event.currentTarget.value);

    this.setState({
      configs,
      teveAlteracao: true,
    });
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(
  null,
  mapDispatchToProps
)(ConfigMapaMacroscopicoContainer);



// WEBPACK FOOTER //
// ./src/pages/configuracao/tab/mapa_macroscopico/mapa-macroscopico.container.js